import type { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { logger } from '@/utils/logger'

import { ErrorFallback } from './ErrorFallback'

interface RouteErrorBoundaryProps {
  children: ReactNode
}

export function RouteErrorBoundary({ children }: RouteErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => logger.error('Route error caught by boundary', error, 'unexpected')}
    >
      {children}
    </ErrorBoundary>
  )
}
